import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarService } from '../navbar/navbar.service';
import * as globals from '../globals';
declare var openNewBrowserWindow: any;

@Component({
  selector: 'app-shareview',
  templateUrl: 'shareview.component.html',
  styleUrls: ['shareview.component.css']
})
export class ShareviewComponent implements OnInit {

  private fileurl: string;
  private pdfurlbool: boolean;

  constructor(private router: Router,
              public navService: NavbarService) { }

  ngOnInit() {
    this.navService.hide();
    let urlSplit = this.router.url.split('file=');
    if (urlSplit.length == 2) {
      this.pdfurlbool = false;
      let theurl = urlSplit[1];
      this.fileurl = decodeURIComponent(theurl);
    }

    console.log('Filename path:', this.fileurl);

    let pdfurlsplit = this.router.url.split('pdfurl=');
    if (pdfurlsplit.length == 2) {
      this.pdfurlbool = true;
      let theurl = pdfurlsplit[1];
      this.fileurl = decodeURIComponent(theurl);
    }
  }

  openInViewer() {
    // Build the URL
    let hwfurl;
    if (!this.pdfurlbool) {
      hwfurl = globals.WEBSITEURL + '/shared/' + this.fileurl;
      //  hwfurl = 'https://webapp.machineresearch.com/shared/' + this.fileurl;
    } else {
      hwfurl = globals.TENANTURL + '/' + globals.BUCKETNAME + '/' + this.fileurl;
      console.log('openInViewer() URL: ', hwfurl);
      openNewBrowserWindow('/#/viewer', hwfurl);
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shareview/shareview.component.ts